<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-download" size="small" plain
            @click.stop="downloadExcel">导出</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-edit" size="small" plain v-if="scope.row.status == 'WAIT_SEND'"
            @click.stop="handleEdit(scope.row, scope.index)">发货
          </el-button>
          <el-button type="text" icon="el-icon-refresh" size="small" plain v-if="showReturnBtn(scope.row)"
            @click.stop="handleReturn(scope.row)">退货
          </el-button>
        </template>
        <template slot-scope="scope" slot="status">
          <el-tag v-if="getLabel(OrderStatus, scope.row.status)">
            {{ getLabel(OrderStatus, scope.row.status) }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="clientType">
          <el-tag v-if="getLabel(clientType, scope.row.clientType)">
            {{ getLabel(clientType, scope.row.clientType) }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="promoteClientType">
          <el-tag v-if="getLabel(clientType, scope.row.promoteClientType)">
            {{ getLabel(clientType, scope.row.promoteClientType) }}
          </el-tag>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 退货弹窗 -->
    <el-dialog title="退货" :visible.sync="returnDialogVisible" :close-on-click-modal="false" width="80%">
      <el-table :data="returnGoodsList" border style="width: 100%">
        <el-table-column prop="goodsName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="skuValue" label="商品规格" align="center"></el-table-column>
        <el-table-column prop="unitPrice" label="购买单价" align="center">
          <template slot-scope="scope">
            ¥{{ (scope.row.saleAmount / scope.row.goodsCount).toFixed(2) || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsCount" label="购买数量" align="center"></el-table-column>
        <!-- availableRefundCount可退数量 -->
        <el-table-column prop="availableRefundCount" label="可退数量" align="center"></el-table-column>
        <el-table-column label="退货数量" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.returnCount" :min="0" :max="scope.row.availableRefundCount"
              :precision="0" :step="1" size="small" controls-position="right"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReturn">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { productOrderDetailsExpressOption } from "@/const/salesCloud/productOrderDetailsExpressOption";
import {
  findDetail,
  findCompany,
  send,
  findSendData,
  findDetailDownloadExcel,
  returnOrder,
  getOrderGoods,
} from "@/api/salesCloud/productOrderDetailsMerchant";

import { DIC } from "@/const/dic";

export default {
  name: "productOrderDetailsExpress",
  data() {
    return {
      tableOption: productOrderDetailsExpressOption,
      tableData: [],
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      downloadData: {},
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      grade: {
        box: false,
        check: [],
      },
      id: this.$route.query.id,
      clientType: DIC.CLIENT_TYPE,
      OrderStatus: [
        { label: '全部', value: '' },
        { label: '待支付', value: 'WAIT_PAY' },
        { label: '待发货', value: 'WAIT_SEND' },
        { label: '待确认', value: 'WAIT_CONFIRM' },
        { label: '已完成', value: 'FINISH' },
        { label: '部分退货', value: 'PART_RETURN' },
        { label: '已退货', value: 'REFUND' },
      ],
      companies: [],
      company: {},
      // 退货弹窗
      returnDialogVisible: false,
      returnGoodsList: [],
      currentReturnRow: null,
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    // 根据value从数组中获取对应label
    getLabel(list, value) {
      const item = list.find(obj => obj.value == value);
      return item ? item.label : '';
    },
    // 判断退货按钮是否显示
    showReturnBtn(row) {
      const allowStatus = ['WAIT_SEND', 'WAIT_CONFIRM', 'FINISH', 'PART_RETURN'];
      if (!allowStatus.includes(row.status)) return false;
      // 判断当天日期 < 收货日期 + 7天
      if (row.payTime) {
        const receiveDate = new Date(row.payTime);
        const deadline = new Date(receiveDate.getTime() + 7 * 24 * 60 * 60 * 1000);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (today >= deadline) return false;
      }
      return true;
    },

    // 打开退货弹窗
    handleReturn(row) {
      this.currentReturnRow = row;
      getOrderGoods(row.id).then((res) => {
        let data = JSON.parse(res.data);
        // 只显示可退数量大于0的商品
        this.returnGoodsList = (data || [])
          .filter(item => Number(item.availableRefundCount) > 0)
          .map(item => ({
            ...item,
            returnCount: 0,
          }));
        if (this.returnGoodsList.length === 0) {
          this.$message({ showClose: true, message: '当前没有可退货的商品', type: 'warning' });
          return;
        }
        this.returnDialogVisible = true;
      });
    },
    // 确认退货
    confirmReturn() {
      const items = this.returnGoodsList.filter(item => Number(item.returnCount) > 0);
      if (items.length === 0) {
        this.$message({ showClose: true, message: "请输入退货数量", type: "warning" });
        return;
      }
      // 二次校验：退货数量不能超过可退数量
      const invalid = items.find(item => Number(item.returnCount) > Number(item.availableRefundCount));
      if (invalid) {
        this.$message({ showClose: true, message: "退货数量不能超过可退数量", type: "warning" });
        return;
      }
      const data = {
        apexId: this.currentReturnRow.apexId,
        items: items.map(item => ({
          orderId: this.currentReturnRow.id,
          skuId: item.skuId,
          refundCount: Number(item.returnCount),
        })),
      };
      returnOrder(data).then((res) => {
        if (res.code == "200") {
          this.$message({ showClose: true, message: "退货成功", type: "success" });
          this.returnDialogVisible = false;
          this.handleList();
        } else {
          this.$message({ showClose: true, message: res.message, type: "error" });
        }
      }).catch((error) => {
        this.$message({ showClose: true, message: error.message || error, type: "error" });
      });
    },
    // 构建搜索参数
    buildSearchParams(params) {
      let result = { ...params };
      // 除了状态和时间，所有搜索字段统一用 searchParams 传参
      const textFields = ['orderNumber', 'goodsName', 'mobile'];
      const textValue = textFields.map(key => (result[key] || '').trim()).find(v => v) || '';
      result.searchParams = textValue;
      // 删除原始文本字段key
      textFields.forEach(key => delete result[key]);
      // 下单时间 - 转时间戳
      if (result.orderStartTime) {
        result.orderStartTime = new Date(result.orderStartTime + ' 00:00:00').getTime();
      } else {
        result.orderStartTime = '';
      }
      if (result.orderEndTime) {
        result.orderEndTime = new Date(result.orderEndTime + ' 23:59:59').getTime();
      } else {
        result.orderEndTime = '';
      }
      // 支付时间 - 转时间戳
      if (result.startTime) {
        result.startTime = new Date(result.startTime + ' 00:00:00').getTime();
      } else {
        result.startTime = '';
      }
      if (result.endTime) {
        result.endTime = new Date(result.endTime + ' 23:59:59').getTime();
      } else {
        result.endTime = '';
      }
      return result;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.buildSearchParams(this.$refs.crud.searchForm);
      params.page = this.page.currentPage;
      params.size = pageSize;
      findDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        data.rows.forEach((item) => {
          item.address = item.address + item.houseNumber;
        });
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.buildSearchParams(this.$refs.crud.searchForm);
      params.page = page;
      params.size = this.page.pageSize;
      findDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        data.rows.forEach((item) => {
          item.address = item.address + item.houseNumber;
        });
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      params = this.buildSearchParams(params);
      params.page = 1;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        data.rows.forEach((item) => {
          item.address = item.address + item.houseNumber;
        });
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: 1,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.buildSearchParams(this.$refs.crud.searchForm);
      params.page = page.currentPage;
      params.size = page.pageSize;
      findDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        data.rows.forEach((item) => {
          item.address = item.address + item.houseNumber;
        });
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    handleEdit(row, index) {
      findSendData(row.id).then((res) => {
        let data = JSON.parse(res.data);
        let costRatio = data.costRatio;
        this.$confirm(`是否确认发货?`, "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let obj = {};
            obj.id = row.id;
            obj.deliveryId = data.shopList[0].distributorId;
            obj.amount = costRatio;
            send(obj)
              .then((response) => {
                if (response.code == "200") {
                  this.$message({
                    showClose: true,
                    message: "发货成功",
                    type: "success",
                  });
                  this.handleList();
                } else {
                  this.$message({
                    showClose: true,
                    message: response.message,
                    type: "error",
                  });
                }
              })
              .catch((error) => {
                this.$message({
                  showClose: true,
                  message: error,
                  type: "error",
                });
              });
          })
          .catch(() => { });
      });
    },
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data)
        data.rows.forEach((item) => {
          item.address = item.address + item.houseNumber;
        });
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    handleSelectionChange() { },
    downloadExcel() {
      let params = this.buildSearchParams(this.$refs.crud.searchForm);
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findDetailDownloadExcel(params).then((res) => {
          console.log(res)
        window.open(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

::v-deep .el-table--medium td {
  padding: 0 !important;
}

::v-deep .el-table {
  font-size: 12px !important;
}

::v-deep .el-form-item {
  margin-bottom: 0px !important;
}

::v-deep .el-table--medium th {
  padding: 0px !important;
}

::v-deep .el-table td .el-table th {
  padding: 0px !important;
}
</style>
